// extracted by mini-css-extract-plugin
export default {"row":"OtpInput_row__6gKaK","digit":"OtpInput_digit__FnKiE"};